export default function PromisesResolver(AdminDescription) {
    return AdminDescription.getPromisesResolver();
}

PromisesResolver.$inject = ['AdminDescription'];



// WEBPACK FOOTER //
// ./src/javascripts/ng-admin/Crud/misc/PromisesResolver.js